"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sok_ui_1 = require("@caddigital/sok-ui");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var React = require("react");
var d3 = require("d3");
require("./style.scss");
var moment = require("moment-timezone");
var parseData = function (entries) {
    if (!entries) {
        return [];
    }
    var arr = [];
    entries.forEach(function (e) {
        var correct = 0;
        var wrong = 0;
        if (e.measurements) {
            e.measurements.forEach(function (m) {
                correct += m.value.correct;
                wrong += m.value.wrong;
            });
            var value = (correct / (correct + wrong)) * 100;
            arr.push({
                date: e.date,
                value: isNaN(value) ? 0 : value
            });
        }
    });
    return arr;
};
var EntryChart = function (props) {
    if (props.status === 'FETCHING') {
        return (React.createElement("div", { className: 'trmvrEntry-view' },
            React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    else if (props.status === 'FAILED' || props.overview.length === 0) {
        return (React.createElement("div", { className: 'trmvrEntry-view' },
            React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-entries", key: "no-entries", title: "diaryEntriesView/emptyList/title", message: "diaryEntriesView/emptyList/message" })));
    }
    var svgRef = React.useRef(null);
    var tooltipRef = React.useRef(null);
    var tooltipTextRef = React.useRef(null);
    var margin = { left: 50, right: 30, top: 30, bottom: 30 };
    var _a = props.dimensions, width = _a.width, height = _a.height;
    var svgWidth = width + margin.left + margin.right;
    var svgHeight = height + margin.top + margin.bottom;
    React.useEffect(function () {
        var data = parseData(props.overview);
        var xScale = d3
            .scaleTime()
            .domain(d3.extent(data, function (d) { return d.date; }))
            .range([0, width]);
        var yScale = d3
            .scaleLinear()
            .domain([
            Math.floor(d3.min(data, function (d) { return d.value; }) / 10) * 10,
            100
        ])
            .range([height, 0]);
        var svgEl = d3.select(svgRef.current);
        var tooltipEl = d3.select(tooltipRef.current);
        var tooltipTextEl = d3.select(tooltipTextRef.current);
        svgEl.selectAll('*').remove();
        var svg = svgEl
            .append('g')
            .attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")"));
        var minValue = d3.min(data, function (d) { return d.date; });
        var maxValue = d3.max(data, function (d) { return d.date; });
        var step = Math.round((maxValue - minValue) / 4);
        var xAxis = d3
            .axisBottom(xScale)
            .tickSize(0)
            .tickFormat(function (val) { return moment(val).format('D.M.YYYY'); });
        if (data.length > 1) {
            // does not show tick labels with 1 item
            xAxis.tickValues(d3.range(minValue, maxValue + step, step));
        }
        else if (data.length === 1) {
            xAxis.ticks(1);
        }
        var xAxisGroup = svg
            .append('g')
            .attr('transform', "translate(0, ".concat(height, ")"))
            .call(xAxis);
        xAxisGroup.selectAll('.domain').attr('stroke', 'rgba(0, 0, 0, 0.2)');
        xAxisGroup.selectAll('.tick line').remove();
        xAxisGroup
            .selectAll('text')
            .attr('opacity', 0.5)
            .attr('color', 'black')
            .attr('font-size', '0.75rem')
            .attr('transform', 'translate(0, 10)');
        var yAxis = d3
            .axisLeft(yScale)
            .ticks(5)
            .tickSizeInner(-width)
            .tickSizeOuter(0)
            .tickFormat(function (val) { return "".concat(val, "%"); });
        var yAxisGroup = svg.append('g').call(yAxis);
        yAxisGroup.selectAll('.domain').attr('stroke', 'rgba(0, 0, 0, 0.2)');
        yAxisGroup.selectAll('.tick:first-of-type line').remove();
        yAxisGroup
            .selectAll('line')
            .attr('stroke', 'rgba(0, 0, 0, 0.2)')
            .attr('stroke-dasharray', '5 5');
        yAxisGroup
            .selectAll('text')
            .attr('opacity', 0.5)
            .attr('color', 'black')
            .attr('font-size', '0.75rem')
            .attr('transform', 'translate(-2, 0)');
        var getCenter = function (event, a, b) {
            var rect = event.target.getBoundingClientRect();
            return rect[a] + (rect[b] - rect[a]) / 2;
        };
        // Line
        var line = d3
            .line()
            .x(function (d) { return xScale(d.date); })
            .y(function (d) { return yScale(d.value); });
        svg
            .append('g')
            .selectAll('line')
            .data(data)
            .enter()
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', '#0084f8')
            .attr('stroke-width', 2)
            .attr('d', line(data));
        // Value dots
        svg
            .append('g')
            .selectAll('circle')
            .data(data)
            .enter()
            .append('circle')
            .attr('fill', 'white')
            .attr('stroke', '#0084f8')
            .attr('stroke-width', 2)
            .attr('cx', function (d) { return xScale(d.date); })
            .attr('cy', function (d) { return yScale(d.value); })
            .attr('r', 3)
            .on('mouseover', function (event, d) {
            tooltipEl
                .style('opacity', 0.9)
                .style('left', getCenter(event, 'left', 'right') - 37 + 'px')
                .style('top', getCenter(event, 'top', 'bottom') - 45 + 'px');
            tooltipTextEl.html(moment(d.date).format('L') + '<br/>' + d.value.toFixed(0) + ' %');
        })
            .on('mouseout', function (d) { return tooltipEl.style('opacity', 0); });
        var newFontSize = 13 * (svgWidth / parseInt(d3.select('svg').style('width'), 10));
        d3.selectAll('.tick').select('text').style('font-size', "".concat(newFontSize, "px"));
        d3.select(window).on('resize', function () {
            var newWidth = d3.select('svg').style('width');
            var newFontSize = 13 * (svgWidth / parseInt(newWidth, 10));
            d3.selectAll('.tick')
                .select('text')
                .style('font-size', "".concat(newFontSize, "px"));
        });
    }, props.overview);
    return (React.createElement("div", { style: { width: '100%' } },
        React.createElement("svg", { ref: svgRef, viewBox: "0 0 ".concat(svgWidth, " ").concat(svgHeight), style: {
                height: '100%',
                width: svgWidth,
                maxWidth: '100%'
            } }),
        React.createElement("div", { ref: tooltipRef, className: "overview-tooltip" },
            React.createElement("div", { ref: tooltipTextRef, className: "overview-tooltip-text" }),
            React.createElement("div", { className: "overview-tooltip-triangle" }))));
};
exports.default = EntryChart;
